var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"capsule-item"},[_c('div',{staticClass:"pg-video-block"},[_c('div',{staticClass:"pg-video-clickbar",on:{"click":_vm.playVideo}},[_c('div',{staticClass:"pg-video-playicon"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89d37854","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-capsule.vue
// module id = null
// module chunks = 